export default "__VITE_ASSET__CIYVmXk4__"